import { render } from "./ClientDepartmentsPanel.vue?vue&type=template&id=7bd65fdf&scoped=true"
import script from "./ClientDepartmentsPanel.vue?vue&type=script&lang=js"
export * from "./ClientDepartmentsPanel.vue?vue&type=script&lang=js"

import "./ClientDepartmentsPanel.vue?vue&type=style&index=0&id=7bd65fdf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bd65fdf"]])

export default __exports__